import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import Button from '../Button';
import Answers from './Answers';
import Question from './Question';
import { ACTIONS, COMMON } from '../../constants/strings';
import { useDynamicQuestionsTree } from './useDynamicQuestionsTree';
import { enhance } from './enhance';

const SequentialSurvey = ({ survey, onSubmit, setProgress }) => {
  const [selectedValue, setSelectedValue] = useState(null);

  const answers = get(survey, 'answers');
  const token = get(survey, 'meta.token');
  const statusSurvey = get(survey, 'meta.status');
  const assignmentId = get(survey, 'assignmentId');
  const questions = get(survey, 'survey.questions');
  const intervieweeId = get(survey, 'interviewee.id');
  const citationVisibleOnQuestions = get(
    survey,
    'survey.citationVisibleOnQuestions',
  );
  const citationLink = get(survey, 'survey.citationLink');
  const citationDescription = get(survey, 'survey.citationDescription');

  const {
    question,
    isComment,
    isRequired,
    handleBack,
    isLastStep,
    isFirstStep,
    handleSubmit,
  } = useDynamicQuestionsTree({
    answers,
    onSubmit,
    questions,
    setProgress,
    selectedValue,
    config: {
      token,
      statusSurvey,
      assignmentId,
    },
  });

  const showCitationLink = citationVisibleOnQuestions && citationDescription;

  const handleSubmitting = () => {
    handleSubmit({
      id: question.id,
      value: selectedValue || question.answerValue,
    });
    setSelectedValue(null);
  };

  const onBack = useCallback(() => {
    handleBack(!!question.parentQuestionId);
  }, [question]);

  const getBtnText = () => {
    if (isLastStep) return <FormattedMessage {...ACTIONS.survey.complete} />;
    if (isComment) return <FormattedMessage {...COMMON.next} />;
    return <FormattedMessage {...ACTIONS.survey.submitOne} />;
  };

  const markOptional = () => <FormattedMessage {...ACTIONS.survey.optional} />;

  const currentAnswer = get(
    question,
    'settings.meta.availableAnswers',
    [],
  ).includes(selectedValue)
    ? selectedValue
    : question.answerValue;

  return (
    <div styleName="root" key={question.id}>
      <div styleName="wrapper">
        <Question
          assignmentId={assignmentId}
          intervieweeId={intervieweeId}
          markOptional={markOptional}
          {...question}
        />
        {showCitationLink && (
          <a href={citationLink} target="blank" styleName="link">
            {citationDescription}
          </a>
        )}
        {!isComment && (
          <div styleName="answer">
            <Answers
              question={question}
              surveyId={assignmentId}
              onChange={setSelectedValue}
              answer={currentAnswer}
            />
          </div>
        )}

        <div styleName="btnGroup">
          <Button
            raised
            type="button"
            color="accent"
            className="mr2"
            onClick={onBack}
            disabled={isFirstStep}
          >
            <FormattedMessage {...COMMON.back} />
          </Button>
          <Button
            raised
            color="primary"
            onClick={handleSubmitting}
            disabled={!(isComment || selectedValue || !isRequired)}
          >
            {getBtnText()}
          </Button>
        </div>
      </div>
    </div>
  );
};

SequentialSurvey.propTypes = {
  onSubmit: PropTypes.func,
  survey: PropTypes.object,
  setProgress: PropTypes.func,
};

export default enhance(SequentialSurvey);



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/index.jsx